
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 12","width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.79 3.9L10.25.35 1.77 8.84v3.54H5.3l8.49-8.49zm-3.54-2.13l2.12 2.12-.7.7-2.12-2.11.7-.71zM8.84 3.18l2.12 2.13-5.66 5.65-2.12-2.12 5.66-5.66zm-6.37 8.49V9.55l2.13 2.12H2.47z","fill":"#8A8888"}})])
          )
        }
      }
    